import { getAddress, getContract } from "viem";
/**
 * Contract implementation.
 */
export class ContractWrapper {
    /**
     * Instance of the deployed contract.
     */
    instance;
    /**
     * Number of a block within which the contract was deployed. Value is read
     * from the contract deployment artifact. It can be overwritten by setting a
     * {@link ContractConfig.deployedAtBlockNumber} property.
     */
    deployedAtBlockNumber;
    /**
     * Address of this contract instance.
     */
    #address;
    /**
     * Abi of this contract instance.
     */
    #abi;
    /**
     * Ethereum client for interacting with chain.
     */
    #client;
    constructor(config, deployment) {
        const contractAddress = config.address ?? getAddress(deployment.address);
        const abi = deployment.abi;
        this.instance = getContract({
            address: contractAddress,
            abi,
            client: config.client,
        });
        this.#address = contractAddress;
        this.#abi = abi;
        this.#client = config.client;
        this.deployedAtBlockNumber = config.deployedAtBlockNumber
            ? config.deployedAtBlockNumber
            : deployment?.receipt?.blockNumber ?? 0;
    }
    /**
     * Get address of the contract instance.
     * @returns Address of this contract instance.
     */
    getAddress() {
        return this.#address;
    }
    /**
     * Get abi of the contract instance.
     * @returns Abi of this contract instance.
     */
    getAbi() {
        return this.#abi;
    }
    /**
     * Get ethereum client for interacting with chain.
     * @returns Ethereum client for interacting with chain.
     */
    getClient() {
        return this.#client;
    }
}
//# sourceMappingURL=contract.js.map